import React from "react"

export interface AccordionPanel {
    heading: React.ReactNode;
    body: React.ReactNode;
    className?: string;
    headingClassName?: string;
}

interface IProps {
    heading: React.ReactNode | ((open: boolean) => React.ReactNode),
    headingStyle?: React.CSSProperties,
    children?: React.ReactNode,
    open?: boolean,
    hasParent?: boolean,
    className?: string,
    headingClassName?: string,
    shown?: (visible: boolean) => void,
    style?: React.CSSProperties,
    childrenContainerStyle?: React.CSSProperties,
    disableToggle?: boolean;
    onClick?: () => void
}
interface IState {
    open: boolean;
}

export class AccordionItem extends React.Component<IProps, IState>{

    constructor(props: IProps) {
        super(props);
        this.state = { open: props.open || false }
    }
    componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.open != this.props.open) {
            this.setState({ open: nextProps.open || false })
        }
    }

    toggle = () => {
        this.setState({ open: !this.state.open })
    }
    onClick = () => {
        this.toggle();
        if (this.props.onClick)
            this.props.onClick();
    }

    setOpen(open: boolean) {
        this.setState({ open })
    }

    render() {
        let stateClass = this.state.open
            ? "is-expanded"
            : "is-collapsed";

        stateClass += this.state.open
            ? " animateIn"
            : " animateOut";

        return (
            <div
                className={this.props.className}
                style={this.props.style}>
                <div
                    className={(this.props.headingClassName || "") + " " + "accordion-title accordionTitle"}
                    onClick={this.onClick}
                    aria-expanded={this.state.open ? "true" : "false"}
                    style={{ cursor: "pointer", ...this.props.headingStyle }}
                >
                    {typeof this.props.heading === "function" ? this.props.heading(this.state.open) : this.props.heading}
                </div>
                {this.state.open && <div
                    style={this.props.childrenContainerStyle}
                    className={`w-100 accordion-content accordionItem ${stateClass}`}
                    aria-hidden="true"
                >
                    {this.props.children}
                </div>}
            </div >
        )
    }
}